// extracted by mini-css-extract-plugin
export var banner = "index-module--banner--07165";
export var bannerImage = "index-module--bannerImage--d3719";
export var logoImage = "index-module--logoImage--a1b91";
export var skillCard = "index-module--skillCard--a50c1";
export var skillCardText = "index-module--skillCardText--a7d81";
export var skillsContainer = "index-module--skillsContainer--01668";